import { type RefObject, useEffect, useState } from "react";

/**
 * Pass all aria-* attributes
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAriaAttributes = (props: any) => {
  const [data, setData] = useState({});

  useEffect(() => {
    const ariaAttributes: Record<string, string> = {};

    for (const key of Object.keys(props)) {
      if (key.startsWith("aria-")) {
        ariaAttributes[key] = props[key];
      }
    }

    setData(ariaAttributes);
  }, [props]);

  return data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSetAriaAttributesToRef = (props: any, ref: RefObject<HTMLElement>) => {
  const ariaAttributes = useAriaAttributes(props);

  useEffect(() => {
    if (ref.current) {
      for (const [key, value] of Object.entries<string>(ariaAttributes)) {
        ref.current.dataset[key.substring(5)] = value;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ariaAttributes]);
};
